import { Link } from "react-router-dom";

export default function LegalFooter() {
  return (
    <footer className="border-t border-ink-10 px-6 py-10 md:px-10">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 text-center md:flex-row md:items-center md:justify-between md:text-left">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-30">
          Windie · local harness for computer-native AI
        </p>
        <nav aria-label="Legal" className="flex justify-center gap-5 font-mono text-[10px] uppercase tracking-[0.16em] text-ink-50 md:justify-end">
          <Link to="/privacy" className="transition-colors hover:text-ink">
            Privacy
          </Link>
          <Link to="/terms" className="transition-colors hover:text-ink">
            Terms
          </Link>
        </nav>
      </div>
    </footer>
  );
}
